import React from 'react';
import { faUserShield, faIdCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import BoolIcon from '../../collection/icons/Boolean';
import ValidacionFilter from '../../components/filters/ValidacionFilter';
import { apiGet, apiForm, getSession } from '../../utils/api';
import { generateFormData, sortableString } from '../../utils/functions';
import { swalertConfirm } from '../../utils/notifications';
import NFCModal from '../../components/modals/NFCModal';

export default function PermisosFichaje(props) {
    const params = useParams();

    // default filter
    const usuario = getSession();
    const defaultFilter = {
        trabajador: params.idTrabajador ? params.idTrabajador : (props.super ? null : usuario.id)
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("usuarios/permisosWebTable", filter);
    };

    // render
    return <>
        <h2>Supervisar permisos fichaje</h2>
        <TableHandler
            onUpdate={updateData}
            elementText="el usuario">
            <ValidacionFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectTrabajador={props.super}
                selectDepartamento={props.super && (usuario.permisoValidacion || usuario.permisoAdmin)} />
            <PermisosWebTable super={props.super} />
        </TableHandler>
    </>;
}

function PermisosWebTable(props) {

    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreCompleto),
            format: row => row.NombreCompleto,
            sortable: true
        },
        {
            name: "Código Tarjeta",
            selector: row => sortableString(row.CodigoPSA),
            format: row => row.CodigoPSA,
            sortable: false
        },
        {
            name: "Fichaje Web",
            selector: row => row.PermisoFichajeWeb,
            format: row => <BoolIcon value={row.PermisoFichajeWeb} size="lg" />,
            sortable: true,
            center: true
        },
    ];

    const handleChangeWebPermission = async (permission, userName, userId) => {
        const ok = await swalertConfirm("",
            permission ? "¿Seguro que quieres cancelar el permiso de fichar por web a " + userName + "?"
                : "¿Seguro que quieres otorgar el permiso de fichar por web a " + userName + "?"
            )
        if (ok) {
            await apiGet("usuarios/changeWebSigningPermission/" + userId);
            props.onFilter();
        }
    }

    // table buttons
    const buttons = row => <>
        <Button variant="main" size="sm" title="Editar código tarjeta" onClick={props.onEdit}><FontAwesomeIcon icon={faIdCard} /></Button>
        <Button variant="main" size="sm" title="Cambiar permiso fichaje web" onClick={() => handleChangeWebPermission(row.PermisoFichajeWeb, row.NombreCompleto, row.Id)}><FontAwesomeIcon icon={faUserShield} /></Button>
    </>;
    const name = row => row.NombreCompleto;

    // render
    return <>
        <DataTable responsive rowname={name} columns={columns} data={props.data} buttons={buttons} pagination />
        {props.formOpen && (
            <NFCModal
                show={props.formOpen}
                onHide={props.onFormClose}
                userId={props.formId}
            />
        )}
    </>;
}
